import { useCallback } from "react";
import styles from "./grid.module.scss";

const hideUnderlineForBreakpoint = {
  desktop: styles.hideUnderLine_desktop,
  tablet: styles.hideUnderline_tablet,
  mobile: styles.hideUnderline_mobile,
};

const firstRowForBreakpoint = {
  desktop: styles.firstRow_desktop,
  tablet: styles.firstRow_tablet,
  mobile: styles.firstRow_mobile,
};

const lastItemInRowForBreakpoint = {
  desktop: styles.lastItemInRow_desktop,
  tablet: styles.lastItemInRow_tablet,
  mobile: styles.lastItemInRow_mobile,
};

const firstItemInRowForBreakpoint = {
  desktop: styles.firstItemInRow_desktop,
  tablet: styles.firstItemInRow_tablet,
  mobile: styles.firstItemInRow_mobile,
};

const lastRowForBreakpoint = {
  desktop: styles.lastRow_desktop,
  tablet: styles.lastRow_tablet,
  mobile: styles.lastRow_mobile,
};

function Grid({
  gridItems,
  desktopColumns,
  tabletColumns,
  mobileColumns,
  gridFlowDirection = "vertical",
  horizontalLineColorInLightMode = "default", //also can be 'scooter'
  hideUnderlineSingleColumn = false,
}) {
  const columns = {
    desktop: desktopColumns,
    tablet: tabletColumns,
    mobile: mobileColumns,
  };

  const getClassNamesForScreenSize = useCallback(
    (index, numItems, columns, screenSize) => {
      let itemClassNames = "";
      const firstRow = index < columns;
      const firstItemInRow = index % columns === 0;
      const lastItemInRow = index % columns === columns - 1;

      const numItemsOnLastRow = numItems % columns;
      const lastRowStartIndex =
        numItems - (numItemsOnLastRow === 0 ? columns : numItemsOnLastRow);
      const lastRow = index >= lastRowStartIndex;

      if (Number(columns) === 1 && hideUnderlineSingleColumn) {
        itemClassNames += ` ${hideUnderlineForBreakpoint[screenSize]}`;
      }

      if (firstRow) {
        itemClassNames += ` ${firstRowForBreakpoint[screenSize]}`;
      }

      if (lastItemInRow) {
        itemClassNames += ` ${lastItemInRowForBreakpoint[screenSize]}`;
      }

      if (firstItemInRow) {
        itemClassNames += ` ${firstItemInRowForBreakpoint[screenSize]}`;
      }

      if (lastRow) {
        itemClassNames += ` ${lastRowForBreakpoint[screenSize]}`;
      }

      return {
        gridItemClassNames: itemClassNames,
      };
    },
    [hideUnderlineSingleColumn]
  );

  const screenSizes = ["desktop", "tablet", "mobile"];

  return (
    <div
      className={styles.root}
      style={{
        "--columns-desktop": columns.desktop,
        "--columns-tablet": columns.tablet,
        "--columns-mobile": columns.mobile,
        "--horizontal-gap-size":
          gridFlowDirection === "vertical" ? "14px" : "0",
        "--vertical-gap-size":
          gridFlowDirection === "horizontal" ? "28px" : "0",
      }}
    >
      {gridItems.map((gridItem, index) => {
        let gridItemClassNames = `${styles.gridItem}`;
        for (const screenSize of screenSizes) {
          const classNames = getClassNamesForScreenSize(
            index,
            gridItems.length,
            columns[screenSize],
            screenSize
          );
          gridItemClassNames += classNames.gridItemClassNames;
        }

        if (horizontalLineColorInLightMode === "scooter") {
          gridItemClassNames += ` ${styles.scooterHorizontalLineColorLight}`;
        }

        return (
          <div key={gridItem.key} className={gridItemClassNames}>
            {gridItem}
          </div>
        );
      })}
    </div>
  );
}

export default Grid;
